import { ChangeDetectionStrategy, Component, inject, input, linkedSignal, output } from '@angular/core';
import { I18NextService } from 'angular-i18next';
import { MbsSize, ModalService } from 'mbs-ui-kit';
import { Observable } from 'rxjs';
import { DisableAutoRenewalModalComponent } from '../disable-auto-renewal-modal/disable-auto-renewal-modal.component';
import { EnableAutoRenewalModalComponent } from '../enable-auto-renewal-modal/enable-auto-renewal-modal.component';

import { SwitcherComponent } from 'mbs-ui-kit';

import { LicenseType } from 'mbs-ui-shared@models';
@Component({
  selector: 'mbs-auto-renewal-switcher',
  templateUrl: './auto-renewal-switcher.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SwitcherComponent]
})
export class AutoRenewalSwitcherComponent {
  private modalService = inject(ModalService);
  private i18nextService = inject(I18NextService);

  license = input<any>();
  isAutoRenew = input<boolean>();
  request = input<Observable<unknown>>();
  disabled = input<boolean>();
  isYearlyLicenseMode = input<boolean>();
  autoRenewChange = output<boolean>();

  isAutoRenewValue = linkedSignal(() => Boolean(this.isAutoRenew() || this.license()?.isAutoRenew));

  public beforeAutoRenewChange(event: { nextValue: boolean; stop: () => void }) {
    event.stop();
    event.nextValue ? this.openEnableAutoRenewModal() : this.openDisableAutoRenewModal();
  }

  public openEnableAutoRenewModal() {
    this.modalService
      .openCustom(EnableAutoRenewalModalComponent, {
        data: {
          title: this.i18nextService.t('shared:licenses.enableAutoRenewalModal.title', {
            format: 'title'
          }),
          itemsCount: 1,
          autoRenewalData: { search: null, ids: [this.license()?.id], enable: false, itemsCount: 1 },
          request: this.request()
        },
        size: MbsSize.sm
      })
      .then(() => {
        this.isAutoRenewValue.set(true);
        this.autoRenewChange.emit(true);
      });
  }

  public openDisableAutoRenewModal() {
    this.modalService
      .openCustom(DisableAutoRenewalModalComponent, {
        data: {
          title: this.i18nextService.t('shared:licenses.disableAutoRenewalModal.title', {
            format: 'title'
          }),
          id: this.license()?.id,
          itemsCount: 1,
          isPremiumSupport: this.license()?.licenseType.id === LicenseType.PremiumSupport,
          isDeepInstinct: this.license()?.licenseType.id === LicenseType.DeepInstinct,
          request: this.request()
        },
        size: MbsSize.sm
      })
      .then(() => {
        this.isAutoRenewValue.set(false);
        this.autoRenewChange.emit(false);
      });
  }
}
